export const init = (survey: any) => {
  const autodate = {
    name: 'autodate',
    title: 'Auto Date',
    iconName: '',
    widgetIsLoaded: () => true,

    isFit: (question) => question.getType() === 'autodate',

    activatedByChanged: (activatedBy) => {
      survey.JsonObject.metaData.addClass('autodate', [], null, 'text');

      survey.JsonObject.metaData.addProperties('autodate', [
        { name: 'setOnCreated:boolean', default: 1 },
        { name: 'setOnUpdated:boolean', default: 0 },
        { name: 'inputType:string', default: 'datetime-local', choices: ['datetime-local', 'date', 'time'] },
      ]);
    },

    isDefaultRender: false,
    htmlTemplate: '<div><input type="datetime-local" id="appt" name="appt"></div>',

    afterRender: (question, el) => {
      const text = el.getElementsByTagName('input')[0];
      text.inputType = question.inputType;
      text.placeholder = question.placeHolder;
      text.setAttribute('disabled', 'disabled');
      text.type = question.inputType;
      if (!question.value) {
        if (question.setOnCreated) {

          const now = new Date();
          now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
          if (question.inputType === 'time') {
            const hh = `00${now.getHours()}`.slice(-2);
            const mm = `00${now.getMinutes()}`.slice(-2);
            text.value = `${hh}:${mm}`;
          } else if (question.inputType === 'date') {
            text.value  = now.toISOString().slice(0,10);
          } else {
            text.value  = now.toISOString().slice(0,16);
          }
          question.value = text.value;
        }
      }

      text.onchange = () => {
        question.value = text.value;
      };
      const onValueChangedCallback = () => {
        text.value = question.value ? question.value : '';
      };
      const onReadOnlyChangedCallback = () => {
      };
      question.readOnlyChangedCallback = onReadOnlyChangedCallback;
      question.valueChangedCallback = onValueChangedCallback;
      onValueChangedCallback();
      onReadOnlyChangedCallback();
    },
    willUnmount: (question, el) => {
      if (question.setOnUpdated) {
        const now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());

        if (question.inputType === 'time') {
          const hh = `00${now.getHours()}`.slice(-2);
          const mm = `00${now.getMinutes()}`.slice(-2);
          question.value = `${hh}:${mm}`;
        } else if (question.inputType === 'date') {
          question.value = now.toISOString().slice(0,10);
        } else {
          question.value = now.toISOString().slice(0,16);
        }
      }
    },
  };

  survey.CustomWidgetCollection.Instance.addCustomWidget(autodate, 'customtype');
};
